import { AudioTranscriptPopper } from '@modules/feedback/components/AudioType/AudioTranscriptPopper';
import { Highlight } from '@modules/feedback/types';
import { Box } from '@mui/material';
import { Feedback, FeedbackLabel } from 'v2/core/entities/feedback';
import { AudioKeywordsAndReasonsSummary } from '@modules/feedback/components/AudioType/AudioKeywordsAndReasonsSummary/AudioKeywordsAndReasonsSummary';

export interface AudioTypeProps {
  feedback: Feedback;
  showOriginalLanguage: boolean;
  highlights: { [key: string]: Highlight[] };
  selectedLabels: FeedbackLabel[] | undefined;
}

export const AudioType = (props: AudioTypeProps) => {
  return (
    <Box height="100%">
      <AudioKeywordsAndReasonsSummary
        selectedLabels={props.selectedLabels}
        feedback={props.feedback}
      />
      <AudioTranscriptPopper {...props} />
    </Box>
  );
};
